// Extracts parameter value for input key present in the current page path.
const extractQueryParamFromPageLocation = (key: string): string => {
  const queryParamValue = window.location.search.replace(
    new RegExp(`^(?:.*[&\\?]${encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&')}(?:\\=([^&]*))?)?.*$`, 'i'),
    '$1',
  )

  const isEncoded = /%[0-9A-F]{2}/i.test(queryParamValue)

  return isEncoded ? decodeURIComponent(queryParamValue) : queryParamValue
}

export default extractQueryParamFromPageLocation
